import React from 'react';

export const GemstoneIcon = ({ className = "w-6 h-6", color = "text-amber-500" }: { className?: string, color?: string }) => (
    <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className={`${className} ${color}`}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M12 2L2 9L12 22L22 9L12 2Z" fillOpacity="0.8" />
        <path d="M12 2L2 9H22L12 2Z" fill="white" fillOpacity="0.2" />
        <path d="M12 22L2 9H22L12 22Z" fill="black" fillOpacity="0.1" />
        <path d="M7 9L12 22L17 9H7Z" fill="white" fillOpacity="0.1" />
    </svg>
);

export const RudrakshaIcon = ({ className = "w-6 h-6", color = "text-amber-700" }: { className?: string, color?: string }) => (
    <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className={`${className} ${color}`}
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="12" cy="12" r="10" fillOpacity="0.8" />
        <path d="M12 2C13 2 13.5 5 14 12C14.5 19 14 22 12 22C10 22 9.5 19 9 12C8.5 5 9 2 12 2Z" fill="black" fillOpacity="0.1" />
        <path d="M12 2C14 2 17 6 17 12C17 18 14 22 12 22" stroke="white" strokeWidth="0.5" strokeOpacity="0.2" fill="none" />
        <path d="M12 2C10 2 7 6 7 12C7 18 10 22 12 22" stroke="white" strokeWidth="0.5" strokeOpacity="0.2" fill="none" />
        <circle cx="12" cy="12" r="3" fill="black" fillOpacity="0.1" />
        <path d="M12 2V22" stroke="white" strokeOpacity="0.1" strokeWidth="1" />
    </svg>
);
export const YogaSparkleIcon = ({ className = "w-6 h-6", color = "text-purple-500" }: { className?: string, color?: string }) => (
    <svg viewBox="0 0 24 24" fill="none" className={`${className} ${color}`} xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z" fill="currentColor" fillOpacity="0.8" />
        <circle cx="12" cy="12" r="3" fill="white" fillOpacity="0.2" />
        <path d="M18 4L19 7L22 8L19 9L18 12L17 9L14 8L17 7L18 4Z" fill="currentColor" fillOpacity="0.4" />
        <path d="M6 16L7 19L10 20L7 21L6 24L5 21L2 20L5 19L6 16Z" fill="currentColor" fillOpacity="0.4" />
    </svg>
);

export const ElephantIcon = ({ className = "w-6 h-6", color = "text-blue-500" }: { className?: string, color?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} ${color}`} xmlns="http://www.w3.org/2000/svg">
        <path d="M22 13C22 10.2386 19.7614 8 17 8H14V7C14 5.34315 12.6569 4 11 4C9.34315 4 8 5.34315 8 7V10H6C4.34315 10 3 11.3432 3 13V15C3 15.5523 3.44772 16 4 16H6V19C6 19.5523 6.44772 20 7 20H9C9.55228 20 10 19.5523 10 19V16H14V19C14 19.5523 14.4477 20 15 20H17C17.5523 20 18 19.5523 18 19V16H20C20.5523 16 21 15.5523 21 15V13H22Z" fillOpacity="0.8" />
        <circle cx="9" cy="8" r="1" fill="white" fillOpacity="0.6" />
        <path d="M22 13C22 14.1046 21.1046 15 20 15V13H22Z" fill="black" fillOpacity="0.1" />
    </svg>
);

export const SunYogaIcon = ({ className = "w-6 h-6", color = "text-amber-500" }: { className?: string, color?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} ${color}`} xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="5" fillOpacity="0.8" />
        <path d="M12 2V5M12 19V22M2 12H5M19 12H22M4.93 4.93L7.05 7.05M16.95 16.95L19.07 19.07M4.93 19.07L7.05 16.95M16.95 7.05L19.07 4.93" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="12" r="3" fill="white" fillOpacity="0.2" />
    </svg>
);

export const MoonYogaIcon = ({ className = "w-6 h-6", color = "text-blue-200" }: { className?: string, color?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} ${color}`} xmlns="http://www.w3.org/2000/svg">
        <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" fillOpacity="0.8" />
        <path d="M18 9A2 2 0 1114 9A2 2 0 0118 9z" fill="white" fillOpacity="0.1" />
    </svg>
);

export const ScalesIcon = ({ className = "w-6 h-6", color = "text-emerald-500" }: { className?: string, color?: string }) => (
    <svg viewBox="0 0 24 24" fill="none" className={`${className} ${color}`} xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3V21M12 5L4 8M12 5L20 8M4 8V11C4 13.2091 5.79086 15 8 15C10.2091 15 12 13.2091 12 11M20 8V11C20 13.2091 18.2091 15 16 15C13.7909 15 12 13.2091 12 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 15V17M16 15V17" stroke="currentColor" strokeWidth="2" />
        <path d="M6 19H10M14 19H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

// Planet Icons
export const SunPlanetIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} text-orange-500`} xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="5" fillOpacity="0.9" />
        <path d="M12 2V4M12 20V22M2 12H4M20 12H22M4.93 4.93L6.34 6.34M17.66 17.66L19.07 19.07M4.93 19.07L6.34 17.66M17.66 6.34L19.07 4.93" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="12" r="2.5" fill="white" fillOpacity="0.3" />
    </svg>
);

export const MoonPlanetIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} text-slate-200`} xmlns="http://www.w3.org/2000/svg">
        <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" fillOpacity="0.9" />
        <circle cx="9" cy="9" r="1.5" fill="white" fillOpacity="0.2" />
        <circle cx="14" cy="14" r="1" fill="white" fillOpacity="0.15" />
    </svg>
);

export const MarsPlanetIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} text-red-500`} xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="14" r="7" fillOpacity="0.9" />
        <path d="M15 9L21 3M21 3H16M21 3V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="10" cy="14" r="3" fill="white" fillOpacity="0.2" />
    </svg>
);

export const MercuryPlanetIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} text-emerald-500`} xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="10" r="5" fillOpacity="0.9" />
        <path d="M12 15V20M9 18H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M8 4C8 4 10 6 12 6C14 6 16 4 16 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="10" r="2" fill="white" fillOpacity="0.3" />
    </svg>
);

export const JupiterPlanetIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} text-yellow-500`} xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" fillOpacity="0.9" />
        <path d="M6 9H18M6 12H16M6 15H14" stroke="white" strokeOpacity="0.3" strokeWidth="1.5" strokeLinecap="round" />
        <ellipse cx="15" cy="14" rx="2" ry="1.5" fill="white" fillOpacity="0.2" />
    </svg>
);

export const VenusPlanetIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} text-pink-400`} xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="9" r="6" fillOpacity="0.9" />
        <path d="M12 15V21M9 18H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="9" r="2.5" fill="white" fillOpacity="0.3" />
    </svg>
);

export const SaturnPlanetIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} text-indigo-400`} xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="6" fillOpacity="0.9" />
        <ellipse cx="12" cy="12" rx="10" ry="3" fill="none" stroke="currentColor" strokeWidth="1.5" strokeOpacity="0.6" transform="rotate(-20 12 12)" />
        <circle cx="12" cy="12" r="2.5" fill="white" fillOpacity="0.2" />
    </svg>
);

export const RahuPlanetIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} text-slate-500`} xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="8" fillOpacity="0.9" />
        <path d="M12 4C8 4 4 8 4 12" stroke="white" strokeWidth="2" strokeOpacity="0.3" strokeLinecap="round" />
        <circle cx="9" cy="10" r="1.5" fill="white" fillOpacity="0.2" />
        <circle cx="15" cy="14" r="2" fill="black" fillOpacity="0.2" />
    </svg>
);

export const KetuPlanetIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} text-amber-600`} xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3L14 8H19L15 11.5L17 17L12 13.5L7 17L9 11.5L5 8H10L12 3Z" fillOpacity="0.9" />
        <path d="M12 21V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="10" r="2" fill="white" fillOpacity="0.3" />
    </svg>
);

export const AscendantIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} text-violet-500`} xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L4 12H8V22H16V12H20L12 2Z" fillOpacity="0.9" />
        <path d="M10 12H14V18H10V12Z" fill="white" fillOpacity="0.2" />
    </svg>
);

export const UranusPlanetIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} text-cyan-400`} xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="15" r="6" fillOpacity="0.9" />
        <path d="M12 9V3M9 5H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="3" r="1.5" fillOpacity="0.9" />
        <circle cx="12" cy="15" r="2.5" fill="white" fillOpacity="0.2" />
    </svg>
);

export const NeptunePlanetIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} text-blue-400`} xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="16" r="5" fillOpacity="0.9" />
        <path d="M12 11V4M8 6L12 2L16 6M8 6V8M16 6V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="12" cy="16" r="2" fill="white" fillOpacity="0.2" />
    </svg>
);

export const PlutoPlanetIcon = ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={`${className} text-purple-300`} xmlns="http://www.w3.org/2000/svg">
        <circle cx="14" cy="7" r="4" fillOpacity="0.9" />
        <path d="M10 7V21M7 18H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M10 7C10 7 10 4 14 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="14" cy="7" r="1.5" fill="white" fillOpacity="0.3" />
    </svg>
);
